import { KMF_CLAIM_PAGE_INDICES } from '../../../actions/kaMetlhaFuneralClaim/types';
import {
    navigateToClaimentDetails,
    navigateToDeceasedDetails,
    navigateToUploadDocuments,
    navigateToSuccessPage,
    //   navigateToThankYou,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
} from '../../../actions/kaMetlhaFuneralClaim/routing';

// import { sendConfirmDetailsSubmitApplication } from "../../../actions/easiplusFuneralPlan/confirmDetails";

// import { performPersonalDetailsValidation } from "./personalDetails";
// import {
//   performLivesCoveredValidation,
//   livesCoveredUpdatePersonalValueRules,
// } from "./livesCovered";
// import { determineBeneficiaryNavigation } from "./beneficiaries";
// import { performBeneficiariesSplitValidation } from "./beneficiariesSplit";
// import { performPaymentDetailsValidation } from "./paymentDetails";
// import { performConfirmDetailsValidation } from "./confirmDetails";

import { getActivePageIndex } from '../../../selectors/kaMetlhaFuneralClaim/routing';
import { getClaimentDetailsValid } from '../../../selectors/kaMetlhaFuneralClaim/claimentDetails';
import { performClaimentDetailsValidation } from './claimentDetails';
import { getDeceasedDetailsValid } from '../../../selectors/kaMetlhaFuneralClaim/deceasedDetails';
import { performDeceasedDetailsValidation } from './deceasedDetails';
import { getUploadDocumentsValid } from '../../../selectors/kaMetlhaFuneralClaim/uploadDocuments';
import { performUploadDocumentsValidation } from './uploadDocuments';
import { sendEmail, sendUploadDocument, setRefNumber } from '../../../actions/kaMetlhaFuneralClaim/referenceData';
// import {
//   getDocuments,
//   getUploadDocumentsValid,
// } from "../../../selectors/digiLifeLoanProtection/uploadDocuments";
// import { performPersonalDetailsValidation } from "./personalDetails";
// import { getPersonalDetailsValid } from "../../../selectors/digiLifeLoanProtection/personalDetails";
// import { performUploadDocumentsValidation } from "./uploadDocuments";
// import {
//   getPaymentDetailsForm,
//   getPaymentDetailsValid,
// } from "../../../selectors/digiLifeLoanProtection/paymentDetails";
// import { performPaymentDetailsValidation } from "./paymentDetails";
// import {
//   getConfirmDetailsValid,
//   getDeclarationsValid,
// } from "../../../selectors/digiLifeLoanProtection/confirmDetails";
// import {
//   sendConfirmDetailsSubmitApplication,
//   validateDeclarations,
// } from "../../../actions/digiLifeLoanProtection/confirmDetails";
// import { transitionScrolling } from "../../../actions/digiLifeLoanProtection/scrolling";
// import { getReplacementPolicyFormIsValid } from "../../../selectors/easiplusFuneralPlan/replacementPolicy";
// import { getPersonalDetailsValid } from "../../../selectors/easiplusFuneralPlan/personalDetails";
// import {
//   getLivesCoveredFormComplete,
//   getCoverMembersForms,
// } from "../../../selectors/easiplusFuneralPlan/livesCovered";
// import { getFormStatusIsValid as getBeneficiariesSplitIsValid } from "../../../selectors/easiplusFuneralPlan/beneficiariesSplit";
// import { getPaymentDetailsValid } from "../../../selectors/easiplusFuneralPlan/paymentDetails";

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) {
        return next(action);
    }

    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);

    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);

    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case KMF_CLAIM_PAGE_INDICES.CLAIMENT_DETAILS:
            !getClaimentDetailsValid(state)
              ? performClaimentDetailsValidation(store)
              :
            store.dispatch(navigateToDeceasedDetails());
            break;

        case KMF_CLAIM_PAGE_INDICES.DECEASED_DETAILS:
            !getDeceasedDetailsValid(state)
              ? performDeceasedDetailsValidation(store)
              :
            store.dispatch(navigateToUploadDocuments());
            break;
        case KMF_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS:
            if(!getUploadDocumentsValid(state)){
                performUploadDocumentsValidation(store)
            } else {
                const buyRef = Math.floor(100000000000 + Math.random() * 900000000000);
                store.dispatch(setRefNumber(buyRef))
                store.dispatch(sendEmail(buyRef));
                store.dispatch(sendUploadDocument())
            }
            
            break;

        case KMF_CLAIM_PAGE_INDICES.SUCCESS_PAGE:
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case KMF_CLAIM_PAGE_INDICES.DECEASED_DETAILS:
            store.dispatch(navigateToClaimentDetails());
            break;

        case KMF_CLAIM_PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToDeceasedDetails());
            break;
    }
};

// const performLivesCoveredNavigation = (store, state) => {
//   const livesCoveredForm = getCoverMembersForms(state);
//   if ("myself" in livesCoveredForm) {
//     livesCoveredUpdatePersonalValueRules(store);
//   }

//   store.dispatch(navigateToLivesCovered());
// };

// const performPaymentDetailsNavigation = (store, state) => {
//   const skipConfirmationPage = getSkipConfirmationPage(state);

//   if (skipConfirmationPage) {
//     const paymentDetailsValid = getPaymentDetailsValid(state);
//     const confirmDetailsValid = getConfirmDetailsValid(state);

//     // Handle payment details valid
//     if (!paymentDetailsValid) performPaymentDetailsValidation(store);

//     // Handle confirm details valid
//     if (!confirmDetailsValid) performConfirmDetailsValidation(store);

//     // Handle success
//     if (paymentDetailsValid && confirmDetailsValid)
//       performThankYouNavigation(store);
//   } else {
//     !getPaymentDetailsValid(state)
//       ? performPaymentDetailsValidation(store)
//       : store.dispatch(navigateToConfirmation());
//   }
// };

// const performConfirmDetailsValidation = (store) => {
//   store.dispatch(validateDeclarations());
//   store.dispatch(transitionScrolling.scrollToId("declaration"));
// };

// const performUplaodDocumentsValidation = (store, state) => {
//   const isValid = isUploadDocumentsValid(store, state);
// };
// const isUploadDocumentsValid = (state) => {
//   const formFields = getDocuments(state);
//   const isValid = (field) => field && field.status === FIELD_STATUS.VALID;

//   // Upload Documents
//   const uploadDocumentsFormFields = [formFields.yourIdProof.membersIdFileName];
//   const uploadDocumentsValid = uploadDocumentsFormFields.every(isValid);

//   return uploadDocumentsValid;
// };
